import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'
import type { StoreApiFetchMenuRequest } from '@itsrever/rever-api'
import { storeApi } from '@/redux/api/store-api-slice'

export const storeMenuQuery = ({
  ecommerceId,
  language,
  countryCode,
  orderReference
}: Partial<StoreApiFetchMenuRequest>) =>
  queryOptions({
    queryKey: [
      'store-menu',
      ecommerceId,
      language,
      countryCode,
      orderReference
    ],
    queryFn:
      ecommerceId !== undefined
        ? async () => {
            const { data } = await storeApi.fetchMenu({
              ecommerceId,
              language,
              countryCode,
              orderReference
            })

            return data
          }
        : skipToken,
    staleTime: 60 * 60 * 1000 // 1 hour
  })

export const useStoreMenu = ({
  ecommerceId,
  language,
  countryCode,
  orderReference
}: Partial<StoreApiFetchMenuRequest>) => {
  return useQuery(
    storeMenuQuery({ ecommerceId, language, countryCode, orderReference })
  )
}
